<template>
  <v-card elevation="2" outlined>
    <v-card-title>
      جزئیات داده
      <v-spacer/>
      <v-icon>mdi-information</v-icon>
    </v-card-title>

    <v-divider/>

    <v-list>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-code-less-than-or-equal</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$options.filters.serviceType(request[0].service)"/>
          <v-list-item-subtitle>اسم سرویس</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-counter</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="persian($options.filters.rial(request[0].Amount))"/>
          <v-list-item-subtitle>قیمت</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-cart</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="request[0].ProductId"/>
          <v-list-item-subtitle>شناسه محصول</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-cart</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$options.filters.productName(request[0].ProductName)"/>
          <v-list-item-subtitle>اسم محصول</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>


      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-shield-check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$options.filters.longDate(request.Date)"/>
          <v-list-item-subtitle>تاریخ </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-message-bulleted</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="data.description"/>
          <v-list-item-subtitle>توضیحات </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

    </v-list>
  </v-card>

</template>

<script>
export default {
  name: "DataDetails",
  data: () => ({
    residenceProvince: null,
    residenceCity: null,
    employmentProvince: null,
    employmentCity: null,

  }),
  props: ['request','data'],

  methods: {
    getUserFile(url) {
      let a = document.createElement('a');
      a.target = '_blank';
      a.href = this.uploadUrl + url;
      a.click();
    },

  }
}
</script>

<style scoped>

</style>